import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { STATUS } from 'constants/miscConstants';
import AdminService from 'services/AdminService';

const { SUCCESS, ERROR } = STATUS;

export const initialState = {
  campaigns: {
    data: { campaigns: [], totalPages: 0, totalCount: 0 },
    loading: false,
    filters: { pageNumber: 1, pageSize: 10 },
  },
  upcomingCalls: {
    data: { calls: [], totalPages: 0, totalCount: 0 },
    loading: false,
    filters: { pageNumber: 1, pageSize: 10 },
  },
  message: '',
  showMessage: false,
  status: SUCCESS,
};

export const getCampaignStats = createAsyncThunk('campaigns/getCampaignStats', async (data, { rejectWithValue }) => {
  const { queryParams, pageNumber, pageSize } = data;
  try {
    const response = await AdminService.getCampaignStats(queryParams);
    return { response, pageNumber, pageSize };
  } catch (err) {
    return rejectWithValue(err?.message || 'Something went wrong');
  }
});

export const getUpcomingScheduledCalls = createAsyncThunk('campaigns/getUpcomingScheduledCalls', async (data, { rejectWithValue }) => {
  const { queryParams, pageNumber, pageSize } = data;
  try {
    const response = await AdminService.getUpcomingScheduledCalls(queryParams);
    return { response, pageNumber, pageSize };
  } catch (err) {
    return rejectWithValue(err?.message || 'Something went wrong');
  }
});

export const campaignsSlice = createSlice({
  name: 'campaigns',
  initialState,
  reducers: {
    hideMessage: (state) => {
      state.message = '';
      state.status = SUCCESS;
      state.showMessage = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCampaignStats.pending, (state) => {
        state.campaigns.loading = true;
      })
      .addCase(getCampaignStats.fulfilled, (state, action) => {
        const { response, pageNumber, pageSize } = action.payload;
        state.campaigns.data = response || initialState.campaigns.data;
        state.campaigns.filters = { pageNumber, pageSize };
        state.campaigns.loading = false;
      })
      .addCase(getCampaignStats.rejected, (state, action) => {
        state.campaigns.loading = false;
        state.status = ERROR;
        state.message = action.payload;
        state.showMessage = true;
      })

      .addCase(getUpcomingScheduledCalls.pending, (state) => {
        state.upcomingCalls.loading = true;
      })
      .addCase(getUpcomingScheduledCalls.fulfilled, (state, action) => {
        const { response, pageNumber, pageSize } = action.payload;
        state.upcomingCalls.data = response || initialState.upcomingCalls.data;
        state.upcomingCalls.filters = { pageNumber, pageSize };
        state.upcomingCalls.loading = false;
      })
      .addCase(getUpcomingScheduledCalls.rejected, (state, action) => {
        state.upcomingCalls.loading = false;
        state.status = ERROR;
        state.message = action.payload;
        state.showMessage = true;
      });
  },
});

export const { hideMessage } = campaignsSlice.actions;

export default campaignsSlice.reducer;
